import axios from 'axios';

const api = axios.create({
  baseURL: 'https://ishqnamaart.in/api',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage
      localStorage.removeItem('token');
      // Redirect to home page (login)
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api; 